<template lang="pug">
div.container-fluid
	.row
		.col-xs-12.col-sm-12.col-md-4.col-lg-3.col-xl-2
			Detalle(v-if="usuario" :idUsuario="usuario.ID", :card="true")
		.col-xs-12.col-sm-12.col-md-8.col-lg-9.col-xl-10
			.card
				.card-header Registro de mis horas
				.card-body
					.row
						.col-xs-12.col-sm-12.col-md-3.col-lg-3.col-xl-3
							.form-group
								label Filtra por palabras
								input.form-control(v-model="filtro.descripcion", @keypress.enter="buscar")
						.col-xs-12.col-sm-12.col-md-3.col-lg-3.col-xl-3
							.row
								.col-xs-12.col-sm-12.col-md-12.col-lg-6.col-xl-6
									.form-group
										label Fecha de inicio
										datepicker(
											v-model="filtro.fechaInicio"
											:bootstrap-styling="true"
											:language="$dateLang"
											@selected="buscar"
										)
								.col-xs-12.col-sm-12.col-md-12.col-lg-6.col-xl-6
									.form-group
										label Fecha de fin
										datepicker(
											v-model="filtro.fechaFin"
											:bootstrap-styling="true"
											:language="$dateLang"
											@selected="buscar"
										)
						.col-xs-12.col-sm-12.col-md-3.col-lg-3.col-xl-3
							.form-group
								label Tipo de registro
								div
									.btn-group
										button.btn(
											@click="setTipoRegistro(null)"
											:class="(filtro.tipo_registro === null) ? 'btn-primary' : ''"
										) Todos
										button.btn(
											@click="setTipoRegistro('acumula')"
											:class="(filtro.tipo_registro === 'acumula') ? 'btn-primary' : ''"
										) Acumula
										button.btn(
											@click="setTipoRegistro('consume')"
											:class="(filtro.tipo_registro === 'consume') ? 'btn-primary' : ''"
										) Consume
						.col-xs-12.col-sm-12.col-md-3.col-lg-3.col-xl-3
							.form-group
								label Estado
								div
									.btn-group
										button.btn(
											@click="setEstado(null)"
											:class="(filtro.estado === null) ? 'btn-primary' : ''"
										) Todos
										button.btn(
											@click="setEstado('validado')"
											:class="(filtro.estado === 'validado') ? 'btn-primary' : ''"
										) Validados
										button.btn(
											@click="setEstado('novalidado')"
											:class="(filtro.estado === 'novalidado') ? 'btn-primary' : ''"
										) Sin validar
				.card-footer
					button.btn.btn-primary(@click="buscar")
						span.fa.fa-search.mr-2
						| Buscar

			.card.mt-3
				.card-header.bg-info.text-white
					.row
						.col.text-left
							span.fa.fa-list.mr-2
							| Resultados
						.col.text-right(v-if="resumen")
							b(v-if="resumen.horas > 0") Tienes {{resumen.horas}} horas para consumir
							b(v-else) Debes {{resumen.horas}} horas
				table.table.table-striped
					thead
						tr
							th ID
							th(style="min-width:100px;") Fecha
							th Acumula
							th Consume
							th Descripcion
							th Aprobado por
							th Eliminar
					tbody
						tr(v-for="registro in registros", :key="registro.ID_registro", style="cursor:pointer;", @click="verRegistro(registro)")
							td {{registro.ID_registro}}
							td {{registro.fechaUnix | moment('DD-MM-YYYY')}}
							td.text-center
								span(v-if="registro.tipo_registro === 'acumula'") +{{registro.horasRaw}}
							td.text-center
								span(v-if="registro.tipo_registro === 'consume'") {{registro.horasRaw}}
							td {{registro.descripcion}}
							td
								div {{registro.validadorNombre}}
								div(style="font-style:italic;") {{registro.aprobado}}
							td
								button.btn.btn-danger(v-if="!registro.aprobado", @click.stop="eliminar(registro)")
									span.fa.fa-trash.mr-2
									| Eliminar
</template>

<style>
.form-group .vdp-datepicker .input-group > input {
  background-color: white !important;
}


</style>

<script>
import API from '../api'
import { mapGetters } from 'vuex'
import Detalle from '../common/detalle'
export default {
	components: {
		Detalle
	},
	data () {
		return {
			filtro: {
				fechaInicio: new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0),
				fechaFin: new Date(new Date().getFullYear(), 11, 31, 23, 59, 59, 999),
				descripcion: null,
				tipo_registro: null,
				estado: null
			},
			registros: [],
			resumen: null
		}
	},
	created () {
		this.buscar()
		this.getResumen()
	},
	computed: {
		...mapGetters({
			usuario: 'session/usuario'
		})
	},
	methods: {
		getResumen () {
			API.getResumen(true)
				.then(res => {
					this.resumen = (res.data.length === 1) ? res.data[0] : null
				})
				.catch(this.$responseError)
		},
		setTipoRegistro (tipo) {
			this.filtro.tipo_registro = tipo
			this.buscar()
		},
		setEstado (estado) {
			this.filtro.estado = estado
			this.buscar()
		},
		buscar () {
			const filtro = JSON.parse(JSON.stringify(this.filtro))
			filtro.fechaInicio = Math.floor(this.filtro.fechaInicio.getTime() / 1000)
			filtro.fechaFin = Math.floor(this.filtro.fechaFin.getTime() / 1000)

			API.misHoras(filtro)
				.then(res => {
					this.registros = res.data.resultados
					this.horas = res.data.horas
				})
				.catch(e => {
					this.$store.commit('toast/danger', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		verRegistro (registro) {
			this.$router.push('/main/horas-extra/editor/' + registro.ID_registro)
		},
		eliminar (registro) {
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar registro',
				mensaje: `¿Quieres eliminar este registro del usuario?`,
				callback: acepta => {
					if (acepta) {
						API.eliminar(registro.ID_registro)
							.then(res => {
								this.$store.commit('toast/success', {
									titulo: 'Registro eliminado'
								})
								this.buscar()
							})
							.catch(e => {
								this.$store.commit('toast/danger', {
									titulo: 'Error',
									mensaje: e.response.data.error
								})
							})
					}
				}
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-horaria/vue/usuario/usuario.vue